import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAuthHeader } from "../auth";
import { api } from '../api';
import ThumbnailImage from "../components/ThumbnailImage";

export default function ModerationPage() {
  const [requests, setRequests] = useState([]);
  const [statusFilter, setStatusFilter] = useState("PENDING");
  const [photoCache, setPhotoCache] = useState({}); // id → photo

  const uploadHost =
    process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '';

  useEffect(() => {
    api.get(`/change-requests${statusFilter ? `?status=${statusFilter}` : ""}`, {
      headers: getAuthHeader()
    }).then(res => setRequests(res.data));
  }, [statusFilter]);

  useEffect(() => {
    const allPhotoIds = new Set();

    for (const req of requests) {
      try {
        const data = JSON.parse(req.payloadJson);
        const ids = (data.photos || []).map(p => p.id).filter(Boolean);
        ids.forEach(id => allPhotoIds.add(id));
      } catch {}
    }

    const idsToLoad = Array.from(allPhotoIds).filter(id => !(id in photoCache));

    Promise.all(idsToLoad.map(id =>
      api.get(`/photos/${id}`, { headers: getAuthHeader() })
        .then(res => ({ id, photo: res.data }))
        .catch(() => ({ id, photo: null }))
    )).then(results => {
      const newCache = {};
      for (const { id, photo } of results) {
        if (photo) newCache[id] = photo;
      }
      setPhotoCache(prev => ({ ...prev, ...newCache }));
    });
  }, [requests]);


  const approve = (id) =>
    api.post(`/change-requests/${id}/approve`, null, {
      headers: getAuthHeader()
    }).then(() => setRequests(prev => prev.filter(r => r.id !== id)));

  const reject = (id) => {
    const reason = prompt("Причина отклонения:");
    if (!reason) return;
    api.post(`/change-requests/${id}/reject?reason=${encodeURIComponent(reason)}`, null, {
      headers: getAuthHeader()
    }).then(() => setRequests(prev => prev.filter(r => r.id !== id)));
  };

  const renderCard = (req) => {
    let data;
    try {
      data = JSON.parse(req.payloadJson);
    } catch {
      return <p className="text-red-400 text-sm">Ошибка парсинга JSON</p>;
    }

    const title = data.name || data.type?.name || data.product?.name || "Без названия";
    const photos = (data.photos || [])
      .map(p => photoCache[p.id])
      .filter(p => p && p.url);

    return (
      <div>
        <p className="text-lg font-bold">{title}</p>
        <p className="text-sm italic text-gray-400">{req.entityType} {req.action}</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mt-2">
          {photos.map((p, i) => {
            const src = p.url.startsWith('/')
              ? `${uploadHost}${p.url}`
              : p.url;

            return (
              <Link key={i} to={`/photos/${p.id}`} className="block">
                <ThumbnailImage
                  src={src}
                  alt={`Фото ${p.id}`}
                  className="w-full h-24 object-cover rounded hover:opacity-80"
                />
              </Link>
            );
          })}
        </div>
        <div className="text-sm text-gray-400 mt-2 space-y-1">
          {data.year && <p>Год: {data.year}</p>}
          {data.number && <p>Номер: {data.number}</p>}
          {data.belongsTo && <p>Назначение: {data.belongsTo}</p>}
          {data.manufacturer?.name && <p>Производитель: {data.manufacturer.name}</p>}
          {data.description && <p>Описание: {data.description.slice(0, 80)}…</p>}
        </div>
      </div>
    );
  };

  return (
    <div className="p-6 text-white bg-gray-900 min-h-screen">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Заявки на модерацию</h1>
        <select
          className="bg-gray-800 text-white border border-gray-600 px-2 py-1 rounded"
          value={statusFilter}
          onChange={e => setStatusFilter(e.target.value)}
        >
          <option value="PENDING">На модерации</option>
          <option value="APPROVED">Принятые</option>
          <option value="REJECTED">Отклонённые</option>
          <option value="">Все</option>
        </select>
      </div>

      {requests.length === 0 ? (
        <p className="text-gray-400">Нет заявок</p>
      ) : (
        <ul className="space-y-4">
          {requests.map(req => (
            <li key={req.id} className="border border-gray-700 p-4 rounded bg-gray-800">
              {renderCard(req)}
              <div className="mt-3 space-x-2">
                {req.status === "PENDING" && (
                  <>
                    <button onClick={() => approve(req.id)} className="bg-green-600 hover:bg-green-700 px-3 py-1 rounded">Принять</button>
                    <button onClick={() => reject(req.id)} className="bg-red-600 hover:bg-red-700 px-3 py-1 rounded">Отклонить</button>
                  </>
                )}
                {req.status !== "PENDING" && (
                  <span className="text-sm italic text-gray-400">{req.status}</span>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
